import { FC } from 'react';
import { timeDiffAgo } from '@aleph/shared-components';
import NotificationItem from 'wb-reddit/app/routes/superGrid/actionRow/notifications/components/notificationItem';
import { ClientGroupedNotifications } from 'wb-reddit/app/routes/superGrid/actionRow/notifications/util';
import redditLogo from 'wb-reddit/assets/reddit-logo.png';

interface NotificationGroupProps {
	notificationGroup: ClientGroupedNotifications;
	onClose: () => void
}

const NotificationGroup: FC<NotificationGroupProps> = ({
	notificationGroup,
	onClose,
}) => (
	<div
		className="flex flex-1 flex-col w-full"
	>
		<div
			className="flex w-full gap-[8px] items-center justify-between py-[8px]"
		>
			<div className="font-semibold text-black flex items-center gap-[16px]">
				<img
					alt="Client image"
					className="min-w-[24px] h-[24px] rounded-full"
					src={notificationGroup.client?.clientProfilePictureUrl ?? redditLogo}
				/>

				<div>
					{notificationGroup?.client?.clientName ?? notificationGroup?.client?.adAccountName ?? 'Ungrouped'}
				</div>
			</div>

			<div className="text-gray-700 text-[12px]">
				{timeDiffAgo(notificationGroup.occurredAt)}
			</div>
		</div>

		<div>{
			notificationGroup.notifications?.map((notification) => (
				<NotificationItem
					key={notification.notificationId}
					notification={notification}
					onClose={onClose}
				/>
			))
		}</div>

		<div
			className="h-[1px] border-b border-b-gray-400 ml-[36px] my-[12px]"
		/>
	</div>
);

export default NotificationGroup;
